
import {Component, Prop, Vue} from "vue-property-decorator";
  import {IApp} from "@/interfaces/app.interface";
  import AppSwitch from "@/components/AppSwitch.vue";
  import {cookieBannerHelper} from "@/shared/CookieBanner/helpers/cookie-banner-helper";
  import {bus} from "@/plugins/bus";
  import {ICookieBanner} from "@/shared/CookieBanner/interfaces/cookie-banner.interface";

  @Component({
    components: {
      AppSwitch,
    }
  })
  export default class ThemeSwitcher extends Vue {
    @Prop({ default: false }) hideText!: boolean;

    isDarkTheme = false;
    availableOptionalProps = false;

    created() {
      this.availableOptionalProps = cookieBannerHelper.cookieConfig.optional;

      let cookieTheme = Vue.cookie.get(IApp.GlobalCookie.AppThemeName);
      if (!this.availableOptionalProps) cookieTheme = '';

      const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');
      let isSystemDarkTheme = darkModeQuery.matches;
      if (!!cookieTheme && cookieTheme === IApp.ThemeName.Dark
        || !cookieTheme && isSystemDarkTheme) {
        this.isDarkTheme = true;
      }
    }

    mounted() {
      bus.$on(ICookieBanner.Event.ChangeCookieValue, () => {
        this.availableOptionalProps = cookieBannerHelper.cookieConfig.optional;
      });
    }

    setTheme(value: boolean) {
      this.isDarkTheme = value;
      let themeName = value ? IApp.ThemeName.Dark : IApp.ThemeName.Light;
      Vue.cookie.set(IApp.GlobalCookie.AppThemeName, themeName, {expires: '10Y'});
      document.documentElement.setAttribute('data-theme', themeName);
    }

    destroyed() {
      bus.$off(ICookieBanner.Event.ChangeCookieValue);
    }
  }
